import paymentsService from '@/services/paymentsService'

const state = {
  chargeTypes: [],
  totalChargeTypes: 0,
  loadingChargeTypes: true,
  // Daily Usage
  dailyUsage: [],
  totalDailyUsage: 0,
  loadingDailyUsage: true,
  paginationDailyUsage: {},
  // Detailed Usage
  searchDetailedUsage: {},
  showDialogTransactionDetails: false,
  detailedUsage: [],
  totalDetailedUsage: 0,
  loadingDetailedUsage: true,
  paginationDetailedUsage: {},
  // Payments
  payments: [],
  totalPayments: 0,
  loadingPayments: false,
  paginationPayments: {},
  // Warning dialog
  showWarningPaymentStateDialog: false,
  // Dialog on superdashboard to charge any account
  showSuperUserChargeAccountDialog: false,
  // Credit card settings in general Settings
  newStripeCreditCard: {},
  loadingAddCreditCard: false,
  creditCards: []
}

const mutations = {
  SET_CHARGE_TYPES (state, chargeTypes) {
    state.chargeTypes = chargeTypes
  },
  SET_TOTAL_CHARGE_TYPES (state, totalChargeTypes) {
    state.totalChargeTypes = totalChargeTypes
  },
  SET_LOADING_CHARGE_TYPES (state, loadingChargeTypes) {
    state.loadingChargeTypes = loadingChargeTypes
  },
  SET_DAILY_USAGE (state, usage) {
    state.dailyUsage = usage
  },
  SET_TOTAL_DAILY_USAGE (state, total) {
    state.totalDailyUsage = total
  },
  SET_LOADING_DAILY_USAGE (state, value) {
    state.loadingDailyUsage = value
  },
  SET_PAGINATION_DAILY_USAGE (state, pagination) {
    state.paginationDailyUsage = pagination
  },
  SET_SEARCH_DETAILED_USAGE (state, searchObj) {
    state.searchDetailedUsage = searchObj
  },
  TOGGLE_DETAILED_USAGE_DIALOG (state, status) {
    state.showDialogTransactionDetails = status
  },
  SET_DETAILED_USAGE (state, usage) {
    state.detailedUsage = usage
  },
  SET_TOTAL_DETAILED_USAGE (state, total) {
    state.totalDetailedUsage = total
  },
  SET_LOADING_DETAILED_USAGE (state, value) {
    state.loadingDetailedUsage = value
  },
  SET_PAGINATION_DETAILED_USAGE (state, pagination) {
    state.paginationDetailedUsage = pagination
  },
  SET_PAYMENTS (state, payments) {
    state.payments = payments
  },
  SET_TOTAL_PAYMENTS (state, total) {
    state.totalPayments = total
  },
  SET_LOADING_PAYMENTS (state, value) {
    state.loadingPayments = value
  },
  SET_PAGINATION_PAYMENTS (state, pagination) {
    state.paginationPayments = pagination
  },
  TOGGLE_WARNING_PAYMENT_STATE_DIALOG (state, status) {
    state.showWarningPaymentStateDialog = status
  },
  TOGGLE_NEW_PAYMENT_SUPERUSER_DIALOG (state, status) {
    state.showSuperUserChargeAccountDialog = status
  },
  SET_NEW_STRIPE_CREDIT_CARD (state, newCard) {
    state.newStripeCreditCard = newCard
  },
  SET_LOADING_ADD_CREDIT_CARD (state, status) {
    state.loadingAddCreditCard = status
  },
  SET_CREDIT_CARD_LIST (state, cardList) {
    state.creditCards = cardList
  }
}

const actions = {
  async changeCardPriorityToMain (vuexContext, cardId) {
    await paymentsService.changeCardPriorityToMain(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      cardId
    )

    vuexContext.dispatch('getListCreditCards')
    return true
  },
  getChargeTypes (vuexContext) {
    vuexContext.commit('SET_LOADING_CHARGE_TYPES', true)
    paymentsService
      .getChargeTypes(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid
      )
      .then(response => {
        const chargeTypes = response.chargeTypes
        for (let i = 0; i < chargeTypes.length; i++) {
          const el = chargeTypes[i]
          if (vuexContext.getters.companyBalance >= 0) {
            try { el.quantity = ((vuexContext.getters.companyBalance / parseFloat(el.amount)).toFixed(0)) } catch (err) {
              el.quantity = ''
            }
          } else {
            el.quantity = '0'
          }
          el.amount = parseFloat(el.amount).toFixed(4)
        }
        vuexContext.commit('SET_CHARGE_TYPES', chargeTypes)
        vuexContext.commit('SET_TOTAL_CHARGE_TYPES', chargeTypes.length)
        vuexContext.commit('SET_LOADING_CHARGE_TYPES', false)
      })
      .catch(() => {
        vuexContext.commit('SET_CHARGE_TYPES', [])
        vuexContext.commit('SET_TOTAL_CHARGE_TYPES', 0)
        vuexContext.commit('SET_LOADING_CHARGE_TYPES', false)
      })
  },
  getDailyUsage (vuexContext) {
    vuexContext.commit('SET_LOADING_DAILY_USAGE', true)
    paymentsService.getDailyUsage(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      {},
      vuexContext.state.paginationDailyUsage)
      .then(response => {
        vuexContext.commit('SET_DAILY_USAGE', response.transactions.rows)
        vuexContext.commit('SET_TOTAL_DAILY_USAGE', response.transactions.count)
        vuexContext.commit('SET_LOADING_DAILY_USAGE', false)
      })
      .catch(() => {
        vuexContext.commit('SET_DAILY_USAGE', [])
        vuexContext.commit('SET_TOTAL_DAILY_USAGE', 0)
        vuexContext.commit('SET_LOADING_DAILY_USAGE', false)
      })
  },
  getDetailedUsage (vuexContext) {
    vuexContext.commit('SET_LOADING_DETAILED_USAGE', true)
    paymentsService.getDetailedUsage(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.state.searchDetailedUsage,
      vuexContext.state.paginationDetailedUsage)
      .then(response => {
        vuexContext.commit('SET_DETAILED_USAGE', response.transactionsMv.rows)
        vuexContext.commit('SET_TOTAL_DETAILED_USAGE', response.transactionsMv.count)
        vuexContext.commit('SET_LOADING_DETAILED_USAGE', false)
      })
      .catch(() => {
        vuexContext.commit('SET_DETAILED_USAGE', [])
        vuexContext.commit('SET_TOTAL_DETAILED_USAGE', 0)
        vuexContext.commit('SET_LOADING_DETAILED_USAGE', false)
      })
  },
  getPayments (vuexContext) {
    vuexContext.commit('SET_LOADING_PAYMENTS', true)
    paymentsService.getPayments(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      {},
      vuexContext.state.paginationPayments)
      .then(response => {
        vuexContext.commit('SET_PAYMENTS', response.transactions.rows)
        vuexContext.commit('SET_TOTAL_PAYMENTS', response.transactions.count)
        vuexContext.commit('SET_LOADING_PAYMENTS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_PAYMENTS', [])
        vuexContext.commit('SET_TOTAL_PAYMENTS', 0)
        vuexContext.commit('SET_LOADING_PAYMENTS', false)
      })
  },
  async getTransactionMovements (vuexContext) {
    await paymentsService.getTransactionMovements(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      'Transacciones')
    return true
  },
  checkPaymentState (vuexContext) {
    if (vuexContext.getters.companyPaymentState === 'warning') {
      vuexContext.commit('TOGGLE_WARNING_PAYMENT_STATE_DIALOG', true)
    }
  },
  async getListCreditCards (vuexContext) {
    try {
      const response = await paymentsService.getListCreditCards(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid
      )

      if (!response) return

      for (let i = 0; i < response.paymentCards.count; i++) {
        response.paymentCards.rows[i].main = i === 0
      }

      vuexContext.commit('SET_CREDIT_CARD_LIST', response.paymentCards.rows)
    } catch (e) {
      vuexContext.commit('SET_CREDIT_CARD_LIST', [])
      throw e
    }
  },
  async getListCreditCardsOfCompany (vuexContext, data) {
    const { companyUuid } = data
    return await paymentsService.getListCreditCardsOfCompany(
      vuexContext.getters.token,
      companyUuid,
      {}
    )
  },
  async addCreditCard (vuexContext, data) {
    try {
      await paymentsService.addCreditCard(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        data)
      vuexContext.dispatch('getListCreditCards')
    } catch (e) {
      throw new Error(e)
    }
  },
  async addCreditCardStripe (vuexContext, data) {
    await paymentsService.addCreditCardStripe(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      data)
    vuexContext.dispatch('getListCreditCards')
  },
  async addCreditCardPaymentez (vuexContext, data) {
    const response = await paymentsService.addCreditCardPaymentez(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      data
    )
    await vuexContext.dispatch('getListCreditCards')
    return response
  },
  async chargeBalance (vuexContext, { amount, companyId, description, gift, invoice }) {
    return await paymentsService.chargeBalance(
      vuexContext.getters.token,
      { amount, companyId, description, gift, invoice })
  },
  async deleteCard (vuexContext, cardId) {
    await paymentsService.deleteCard(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      cardId
    )

    vuexContext.dispatch('getListCreditCards')
    return true
  },
  async newPayment (vuexContext, data) {
    const { accountToCharge } = data

    if (accountToCharge === 'ownerAccount') {
      await paymentsService.chargeOwnAccount(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        data
      )
      return true
    }

    if (accountToCharge === 'otherAccount') {
      await paymentsService.newPaymentOtherCompany(
        vuexContext.getters.token,
        data
      )
      return true
    }
  }
}

const getters = {
  mainCreditCard (state) {
    const mainCreditCard = state.creditCards.filter((el) => el.main)
    return mainCreditCard.length > 0 ? mainCreditCard[0] : {}
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
